import React from 'react';
import PropTypes from 'prop-types';
import Item from './item/main';
import Submenu from './submenu/main';
import Subitem from './subitem/main';
import './main.less';

class Menu extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (<ul className="main-menu__menu">{this.props.children}</ul>);
	}
}

Menu.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	])
};

Menu.Item = Item;
Menu.Submenu = Submenu;
Menu.Subitem = Subitem;

export { Item, Submenu, Subitem };
export default Menu;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/components/menu/main.js